import React, { PropsWithChildren, useState } from 'react'
import { Popover } from '@headlessui/react'
import { usePopper } from 'react-popper'
import Button, { ButtonSize, ButtonVariant } from './Button'
import './Menu.css'
import { Placement } from '@popperjs/core'
import { ThreeDotsIcon } from './icons'

interface MenuProps {
    thing?: string
    variant?: ButtonVariant
    size?: ButtonSize
    placement?: Placement
    button?: React.ReactNode
}

interface MenuItemProps {
    icon?: React.ReactNode
    onClick?: () => void
    close?: () => void
}

export function MenuItem({ children, onClick, close, icon }: PropsWithChildren<MenuItemProps>) {
    return (
        <div className="ui-menu-item"
            onClick={(event) => {
                onClick?.()
                close?.()
                event.preventDefault()
                event.stopPropagation()
            }}>
            {icon && <span className="menu-item-icon">{icon}</span>}
            <span className="menu-item-title">{children}</span>
        </div>
    )
}

export default function Menu({ children, variant, size, placement, button }: PropsWithChildren<MenuProps>) {
    const [referenceElement, setReferenceElement] = useState<Element | null | undefined>()
    const [popperElement, setPopperElement] = useState<HTMLElement | null | undefined>()
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement: placement ?? 'bottom-end',
    })
    const defaultButton = button ?? <Button
        variant={variant ?? 'secondary'}
        size={size ?? 'tiny'}
        icon={<ThreeDotsIcon />} />

    return (
        <Popover>
            {({ close }) => (
                <>
                    <Popover.Button as="div" ref={setReferenceElement}>{defaultButton}</Popover.Button>
                    <Popover.Panel
                        ref={setPopperElement}
                        style={styles.popper as any}
                        {...attributes.popper}
                        className="ui-menu"
                    >
                        {React.Children.map(children, (child) =>
                            React.isValidElement(child)
                                ? React.cloneElement(child, { close } as any)
                                : child,
                        )}
                    </Popover.Panel>
                </>
            )}
        </Popover>
    )
}
